var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarkdown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6857 5.33221H2.31433C2.14205 5.33238 1.97675 5.26411 1.8548 5.14241C1.73285 5.02071 1.66424 4.85556 1.66406 4.68327V3.3147C1.66389 3.14241 1.73216 2.97711 1.85386 2.85516C1.97556 2.73322 2.14071 2.66461 2.313 2.66443H13.6864C14.0452 2.66443 14.336 2.95527 14.336 3.31403V4.6826C14.336 4.85489 14.2676 5.02012 14.1457 5.14194C14.0239 5.26377 13.8587 5.33221 13.6864 5.33221H13.6857Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4415 13.3355H4.55867C3.86493 13.3355 3.28703 12.8037 3.22945 12.1124L2.66455 5.33221H13.3357L12.7708 12.1124C12.7132 12.8037 12.1353 13.3355 11.4415 13.3355Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 10.9006V8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66626 9.56665L8.00015 10.9005L9.33404 9.56665",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarkdown);
export default ForwardRef;